export const imageData = [
    {
        id: 1,
        name: 'makeup-pictures',
        url: 'https://instagram.flos1-1.fna.fbcdn.net/v/t51.2885-15/sh0.08/e35/p640x640/141513337_437459484123463_7697780776564686617_n.jpg?_nc_ht=instagram.flos1-1.fna.fbcdn.net&_nc_cat=107&_nc_ohc=CgMFhFuEm58AX-hDg5R&tp=1&oh=187eba252d9af295bc879178aefd6773&oe=6035F034'
    },
    {
        id: 2,
        name: 'makeup-pictures',
        url: 'https://instagram.flos1-1.fna.fbcdn.net/v/t51.2885-15/e35/p1080x1080/128645743_1087845554970580_2919344977081286439_n.jpg?_nc_ht=instagram.flos1-1.fna.fbcdn.net&_nc_cat=104&_nc_ohc=SD16Pw06W94AX8k5gUl&tp=1&oh=30554cf9d16a9eb886bacce054168a01&oe=60375EDE'
    },
    {
        id: 3,
        name: 'makeup-pictures',
        url: 'https://instagram.flos1-1.fna.fbcdn.net/v/t51.2885-15/e35/p1080x1080/128127700_1749665431861059_321683194129459160_n.jpg?_nc_ht=instagram.flos1-1.fna.fbcdn.net&_nc_cat=103&_nc_ohc=N8yH-k2p-XwAX-RYtjh&tp=1&oh=ca812136b89071f8c0fad9c174856faf&oe=6037E5FE'
    },
    {
        id: 4,
        name: 'makeup-pictures',
        url: 'https://instagram.flos1-1.fna.fbcdn.net/v/t51.2885-15/sh0.08/e35/p750x750/124846938_712045376411511_2642231047224398388_n.jpg?_nc_ht=instagram.flos1-1.fna.fbcdn.net&_nc_cat=103&_nc_ohc=E5WXObGBlFsAX_c260U&tp=1&oh=804492dbba27d93ff97306d63469353e&oe=6037C213'
    },
    {
        id: 5,
        name: 'makeup-pictures',
        url: 'https://instagram.flos1-1.fna.fbcdn.net/v/t51.2885-15/e35/p1080x1080/121479934_198988674967984_2705903690356444881_n.jpg?_nc_ht=instagram.flos1-1.fna.fbcdn.net&_nc_cat=104&_nc_ohc=zYkTi3mgfUcAX9YbpFx&tp=1&oh=95444385a7a7c8bdc6fea4bea9831981&oe=60373252'
    },
    {
        id: 6,
        name: 'makeup-pictures',
        url: 'https://instagram.flos1-1.fna.fbcdn.net/v/t51.2885-15/sh0.08/e35/p750x750/119866162_2804896359794912_7889201816008610581_n.jpg?_nc_ht=instagram.flos1-1.fna.fbcdn.net&_nc_cat=108&_nc_ohc=YpSnIiBt-rwAX-PVRXa&tp=1&oh=a3a3cd11a5c16a797c45bd67ee37882d&oe=60355208'
    },
]

export const ceoImage = [
    {
        id: 1,
        name: 'Mrs Dumsira Menegbo',
        url: 'https://scontent.flos1-1.fna.fbcdn.net/v/t1.0-9/126882470_3271663359629440_6691126653650370989_o.jpg?_nc_cat=111&ccb=2&_nc_sid=09cbfe&_nc_eui2=AeGjim5wrGXc2_2CHCcc8gXj9rGp8PMeOdX2sanw8x451VzSNbyumIvpJXfPoDeMnpBz4lRU2Zm6piahU5r9bfGL&_nc_ohc=pOpPnBAj3XIAX-vkfRH&_nc_ht=scontent.flos1-1.fna&oh=ef9e2df0ca820ed6cef8b56df4ca970d&oe=60326C13',
        details: "Hi!, I am Dumsira. It's my pleasure meeting with you to showcase my designs to you. My company is known for delivering high quality makeup services as well as outdoor services like weddings, anniversary, etc. We look forward hearing from you. Thank you." 
    }
]

